import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { generateSentimentsStrategy } from 'utils/insightModal/strategy/searchFilterComposing'

const useSearchFilterComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const searchFilterComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.POSITIVE_NEGATIVE:
      case InsightViewOption.POSITIVE_NEGATIVE_NEUTRAL:
        return generateSentimentsStrategy()
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

  return searchFilterComposingStrategy
}

export default useSearchFilterComposingStrategy
